import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MinimizeIcon from '@mui/icons-material/Minimize';
import CropFreeIcon from '@mui/icons-material/CropFree';
import FilterNoneIcon from '@mui/icons-material/FilterNone';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import './DashboardHeader.scss';

const DashboardHeader = ({
  onClose,
  onMinimize,
  onMaximize,
  isMaximized,
  projectName,
  title,
  showMinimize,
  showMaximize,
  onBackToCustomer,
  onHelp,
  t
}) => {
  return (
    <div className="dashboard-header">
      <Box className="header-left" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {onBackToCustomer && (
          <Tooltip title={t('back_to_customer_dashboard') || t('customer_dashboard')}>
            <IconButton size="small" onClick={onBackToCustomer} className="back-btn" sx={{ color: '#fff' }}>
              <ArrowBackIcon sx={{ color: '#fff' }} />
            </IconButton>
          </Tooltip>
        )}
        <Typography variant="h6" className="dashboard-title">
          {title || t('project_dashboard')}
        </Typography>
      </Box>

      <Box className="header-controls">
        {onHelp && (
          <IconButton
            size="small"
            onClick={onHelp}
            title={t('help') || 'Help'}
          >
            <QuestionMarkIcon />
          </IconButton>
        )}
        {showMinimize && (
          <IconButton
            size="small"
            onClick={onMinimize}
            title={t('minimize')}
          >
            <MinimizeIcon />
          </IconButton>
        )}

        {showMaximize && (
          <IconButton
            size="small"
            onClick={onMaximize}
            title={isMaximized ? t('restore') : t('maximize')}
          >
            {isMaximized ? <FilterNoneIcon /> : <CropFreeIcon />}
          </IconButton>
        )}

        <IconButton
          size="small"
          onClick={onClose}
          title={t('close')}
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </div>
  );
};

DashboardHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
  onMinimize: PropTypes.func,
  onMaximize: PropTypes.func.isRequired,
  isMaximized: PropTypes.bool.isRequired,
  projectName: PropTypes.string,
  title: PropTypes.string,
  showMinimize: PropTypes.bool,
  showMaximize: PropTypes.bool,
  onBackToCustomer: PropTypes.func,
  onHelp: PropTypes.func,
  t: PropTypes.func.isRequired
};

DashboardHeader.defaultProps = {
  showMinimize: true,
  showMaximize: true
};

export default DashboardHeader;
